import { Typography } from '@mui/material';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTodayListeningTime } from '@/hooks/useListeningTime';

function formatListeningTime(seconds: number): string {
  const totalMinutes = Math.floor(seconds / 60);
  if (totalMinutes < 1) return '< 1 min';
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hours === 0) return `${totalMinutes} min`;
  if (mins === 0) return `${hours} hr`;
  return `${hours} hr ${mins} min`;
}

/**
 * ListeningTimeWidget — shows today's total listening time in the player header.
 * Renders nothing until at least 1 second has been tracked today.
 * Refreshes automatically whenever a tracking batch is sent to the server.
 */
export function ListeningTimeWidget() {
  const { t } = useTranslation('player');
  const { totalSeconds } = useTodayListeningTime();

  if (totalSeconds <= 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flexShrink: 0,
        color: 'text.secondary',
      }}
    >
      <AccessTimeIcon sx={{ fontSize: 14 }} />
      <Typography variant="caption" noWrap>
        {t('listeningTimeToday', { time: formatListeningTime(totalSeconds) })}
      </Typography>
    </Box>
  );
}
